/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ElementsUserProfilePartialUpdate
 */
export interface ElementsUserProfilePartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfilePartialUpdate
     */
    avatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfilePartialUpdate
     */
    defaultPage?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfilePartialUpdate
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfilePartialUpdate
     */
    language?: ElementsUserProfilePartialUpdateLanguageEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserProfilePartialUpdate
     */
    fmBookmarks?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum ElementsUserProfilePartialUpdateLanguageEnum {
    En = 'en',
    Fr = 'fr',
    De = 'de',
    Ru = 'ru'
}

export function ElementsUserProfilePartialUpdateFromJSON(json: any): ElementsUserProfilePartialUpdate {
    return ElementsUserProfilePartialUpdateFromJSONTyped(json, false);
}

export function ElementsUserProfilePartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsUserProfilePartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'defaultPage': !exists(json, 'default_page') ? undefined : json['default_page'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'fmBookmarks': !exists(json, 'fm_bookmarks') ? undefined : json['fm_bookmarks'],
    };
}

export function ElementsUserProfilePartialUpdateToJSON(value?: ElementsUserProfilePartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'avatar': value.avatar,
        'default_page': value.defaultPage,
        'full_name': value.fullName,
        'language': value.language,
        'fm_bookmarks': value.fmBookmarks,
    };
}


